import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Sent: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.3514 2.28601C14.1412 2.04461 13.8094 1.9437 13.5009 2.03098L1.60723 5.35389C1.28699 5.44284 1.05039 5.71509 1.00712 6.04431C0.963793 6.37437 1.1208 6.69777 1.40773 6.86797L5.07346 9.03597L10.1753 5.91067L6.36236 10.5229L7.99281 14.4574C8.11464 14.7483 8.38969 14.9452 8.70208 14.9673C8.71948 14.9685 8.73611 14.9688 8.75274 14.9692C9.0856 14.9727 9.38837 14.7776 9.52238 14.4723L14.4859 3.16412C14.614 2.87088 14.5617 2.52823 14.3514 2.28601Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);
